var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenStarsRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 52,
    viewBox: "0 0 138 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15L13.4697 22.6008H21.4616L14.996 27.2984L17.4656 34.8992L11 30.2016L4.53436 34.8992L7.00402 27.2984L0.538379 22.6008H8.53035L11 15Z",
    fill: "#83C5BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10L57.5922 21.0557H69.2169L59.8123 27.8885L63.4046 38.9443L54 32.1115L44.5954 38.9443L48.1877 27.8885L38.7831 21.0557H50.4078L54 10Z",
    fill: "#83C5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112 0L117.837 17.9656H136.727L121.445 29.0689L127.282 47.0344L112 35.9311L96.7176 47.0344L102.555 29.0689L87.2725 17.9656H106.163L112 0Z",
    fill: "#83C5BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStarsRight);
export default __webpack_public_path__ + "static/media/green_stars_right.2bb7c4afbdc2364500a11eab4f4d876a.svg";
export { ForwardRef as ReactComponent };